import {
  Component,
  Renderer2,
  NgZone,
  ChangeDetectorRef,
  OnDestroy,
  ElementRef,
  HostBinding,
} from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import {
  BehaviorSubject,
  Observable,
  ReplaySubject,
  Subject,
  Subscription,
  combineLatest,
  interval,
  merge,
  of,
  timer,
} from "rxjs";
import {
  LobbyFilters,
  TournamentStatus2,
} from "../../../shared/enums/poker-types";
import { AuthService, PlayersStatistics } from "../../../auth/auth.service";
import { User } from "../../../shared/models/user";
import { ManagerService } from "../../../core/services/manager.service";
import {
  CasinoGamesCategory,
  DataManagerService,
} from "../../../core/services/data-manager.service";
import { MainService } from "../../main.service";
import {
  LobbyFilterOptions,
  NavTableData,
  Settings,
  TableSummary,
  Tournament,
  TournamentSummary,
} from "../../../shared/models";
import { GameService } from "../../game/game.service";
import { environment } from "../../../../environments/environment";
import { Colors } from "../../../shared/constants/color.constants";
import { Comparators } from "../../../shared/helpers/comparators";
import { FormControl } from "@angular/forms";
import {
  catchError,
  debounceTime,
  delay,
  distinctUntilChanged,
  finalize,
  map,
  pluck,
  share,
  shareReplay,
  startWith,
  switchMap,
  take,
  takeUntil,
  tap,
  timeout,
} from "rxjs/operators";
import { DialogLegendSymbol } from "../lobby-dialogs/dialog-legend-symbol/dialog-legend-symbol.component";
import { AppWebSocketService } from "../../../core/services/app-web-socket.service";
import { Ticket } from "../../../shared/models/ticket";
import { PasswordDialogComponent } from "../lobby-dialogs/password-dialog/password-dialog.component";
import { GameType } from "../../../shared/enums/game-type.enum";
import { FilterType } from "../../../shared/enums/filter-type";
import { Currency } from "../../../shared/enums";
import { ENavItem } from "../../nav/nav-item-type";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { Howl } from "howler";
import { AssetsLoaderService } from "../../../core/services/assets-loader.service";
import { CurrencyInfo } from "../../../shared/models/currency-info";
import { ConfigService } from "../../../core/services/config.service";
import { GenericTextDialog } from "../../../core/dialogs/generic-text-dialog/generic-text-dialog.component";
import { CurrencyDeviderPipe } from "../../../shared/utils/currency-devider.pipe";
import { CurrencyPipe } from "../../../shared/utils/currency.pipe";
import { EditProfileComponent } from "../../dialogs/edit-profile/edit-profile.component";
import { HttpParams } from "@angular/common/http";
import { DomSanitizer } from "@angular/platform-browser";
import { CursorError } from "@angular/compiler/src/ml_parser/lexer";
export interface TableDataSort {
  direction: string;
  active: string;
  data?: string;
}

export interface FilteringData {
  buyIn: number[];
  status: TournamentStatus2[];
  completed: boolean[];
  hideSatelitites: boolean[];
}

export type LobbyTheme = "dark" | "light";

@Component({
  selector: "app-lobby-container",
  templateUrl: "./lobby-container.component.html",
  styleUrls: ["./lobby-container.component.scss"],
})
export class LobbyContainerComponent implements OnDestroy {
  lobbyTheme: LobbyTheme = "dark";

  @HostBinding("class")
  get lobbyThemeHostClass(): string {
    const classes = [`lobby-theme-${this.lobbyTheme}`];
    if (this.config?.tileLobbyOption) {
      classes.push("tile-lobby-option");
    }
    return classes.join(" ");
  }

  get useWaveLobbyUi(): boolean {
    return !!(this.config?.newLayout || this.config?.tileLobbyOption);
  }

  get isCasinoEnabled(): boolean {
    const value = this.settings?.IsCasinoEnabled;
    return value === true || value === "True" || value === "true";
  }

  get useTrueRakeback(): boolean {
    return this.settings?.UseTrueRakeback?.toLowerCase() === "true";
  }

  get showMyInsights(): boolean {
    return !!(this.config?.tileLobbyOption && this.useTrueRakeback);
  }

  lobbySound: Howl;
  stakeOptions = [
    { label: "menu.filter.option.stakes.allStakes", value: 0 },
    { label: "menu.filter.option.stakes.micro", value: 1 },
    { label: "menu.filter.option.stakes.low", value: 2 },
    { label: "menu.filter.option.stakes.medium", value: 3 },
    { label: "menu.filter.option.stakes.high", value: 4 },
  ];
  speedOptions = [
    { label: "menu.filter.option.speed.all", value: 0 },
    { label: "menu.filter.option.speed.regular", value: 1 },
    { label: "menu.filter.option.speed.fast", value: 2 },
    { label: "menu.filter.option.speed.hyper", value: 3 },
  ];
  limitOptions = [
    { label: "menu.filter.option.limit.allLimits", value: 0 },
    { label: "menu.filter.option.limit.noLimit", value: 1 },
    { label: "menu.filter.option.limit.potLimit", value: 2 },
    { label: "menu.filter.option.limit.fixedLimit", value: 4 },
  ];
  tablesOptions = [
    { label: "All", value: 0 },
    { label: "Hide Empty Tables", value: 1 },
    { label: "Hide Full Tables", value: 2 },
  ];
  buyInOptions = [
    { label: "menu.filter.option.buyIn.all", value: 0 },
    { label: "page.tournament.info.freeroll", value: 10 },
    { label: "menu.filter.option.stakes.low", value: 2 },
    { label: "menu.filter.option.stakes.medium", value: 3 },
    { label: "menu.filter.option.stakes.high", value: 4 },
  ];
  tourStatusOptions = [
    { value: 0, label: "menu.filter.option.stakes.all" },
    { value: 1, label: "tournamentRegister.announced" },
    { value: 2, label: "tournamentRegister.registering" },
    { value: 3, label: "page.tournament.info.lateReg" },
    { value: 4, label: "LABEL.RUNNING" },
  ];
  lobbyFilters = LobbyFilters;
  showFilters = false;
  showDesktopFilters = false;
  isRingGame = false;
  previuosTab: any = null;
  currentTab: any = 1;
  environment = environment;
  selectedStake: number[] = [];
  selectedSpeed: number[] = [];
  selectedLimit: number[] = [];
  showPrivate: number[] = [];
  selectedSortOption: boolean;
  selectedTableOption: number[] = [];
  selectedBuyIn: number[] = [];
  selectedTourStatus: TournamentStatus2[] = [];
  selectedGameType: string | LobbyFilters = "ALL";
  status: TournamentStatus2;
  selectedCompletedOption: boolean[] = [];
  selectedHideSatelitites: boolean[] = [];
  freerollFilter: boolean = false;
  freerollData: any[] = [];
  myTournaments: boolean = false;
  showMyTournaments: boolean = false;
  sitNGoFilters: FilteringData = {} as FilteringData;
  spinNGoFilters: FilteringData = {} as FilteringData;
  tournamentFilters: FilteringData = {} as FilteringData;
  showResetButton = false;
  gameTypeFilter: any = {};
  gameVariantFilter = [
    { displayValue: "Any", realValue: "ALL", type: 0 },

    // Hold'em - - - - - - - - - - - - - - - - - - - - - - - -
    {
      displayValue: "Hold'em Games",
      realValue: [
        LobbyFilters.VariantHoldem,
        LobbyFilters.VariantHoldemRock,
        LobbyFilters.VariantCapTexasHoldEm,
      ],
      type: 0,
    },
    { realValue: LobbyFilters.VariantHoldem, displayValue: "Hold'em", type: 1 },
    {
      realValue: LobbyFilters.VariantHoldemRock,
      displayValue: "Hold'em Rock",
      type: 1,
    },
    {
      realValue: LobbyFilters.VariantCapTexasHoldEm,
      displayValue: "Cap Hold'em",
      type: 1,
    },
    {
      realValue: LobbyFilters.VariantCapTexasHoldEm,
      displayValue: "Cap Hold'em",
      type: 1,
    },
    {
      realValue: LobbyFilters.SixPlusHoldem,
      displayValue: "6+ Hold'em",
      type: 1,
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - -

    // Omaha - - - - - - - - - - - - - - - - - - - - - - - -
    {
      displayValue: "Omaha Games",
      realValue: [
        LobbyFilters.VariantOmaha,
        LobbyFilters.VariantOmahaHiLow,
        LobbyFilters.VariantOmaha3,
        LobbyFilters.VariantOmaha5,
        LobbyFilters.VariantOmaha5HiLow,
        LobbyFilters.VariantOmaha6,
        LobbyFilters.Omaha7,
        LobbyFilters.CapOmaha,
        LobbyFilters.CapOmaha5,
        LobbyFilters.CapOmaha6,
        LobbyFilters.CapOmaha7,
        LobbyFilters.VariantTriOmaha,
      ],
      type: 0,
    },
    { realValue: LobbyFilters.VariantOmaha, displayValue: "Omaha", type: 1 },
    {
      realValue: LobbyFilters.VariantOmahaHiLow,
      displayValue: "Omaha Hi/Lo",
      type: 1,
    },
    { realValue: LobbyFilters.VariantOmaha3, displayValue: "Omaha 3", type: 1 },
    { realValue: LobbyFilters.VariantOmaha5, displayValue: "Omaha 5", type: 1 },
    {
      realValue: LobbyFilters.VariantOmaha5HiLow,
      displayValue: "Omaha 5 Hi/Lo",
      type: 1,
    },
    { realValue: LobbyFilters.VariantOmaha6, displayValue: "Omaha 6", type: 1 },
    { realValue: LobbyFilters.Omaha7, displayValue: "Omaha 7", type: 1 },
    { realValue: LobbyFilters.CapOmaha, displayValue: "Cap Omaha", type: 1 },
    { realValue: LobbyFilters.CapOmaha5, displayValue: "Cap Omaha 5", type: 1 },
    {
      realValue: LobbyFilters.CapOmaha5HiLow,
      displayValue: "CAP 2-7 Omaha 5 Hi/Lo",
      type: 1,
    },
    { realValue: LobbyFilters.CapOmaha6, displayValue: "Cap Omaha 6", type: 1 },
    { realValue: LobbyFilters.CapOmaha7, displayValue: "Cap Omaha 7", type: 1 },
    {
      realValue: LobbyFilters.VariantTriOmaha,
      displayValue: "Tri Omaha",
      type: 1,
    },
    // - - - - - - - - - - - - - - - - - - - - - - - - - - - -

    // Stud Games - - - - - - - - - - - - - - - - - - - - - - - -
    {
      displayValue: "Stud Games",
      realValue: [
        LobbyFilters.Variant7Stud,
        LobbyFilters.SevenStudHiLo,
        LobbyFilters.Razz,
      ],
      type: 0,
    },
    { realValue: LobbyFilters.Variant7Stud, displayValue: "7 Stud", type: 1 },
    {
      realValue: LobbyFilters.SevenStudHiLo,
      displayValue: "7 Stud Hi/Lo",
      type: 1,
    },
    { realValue: LobbyFilters.Razz, displayValue: "Razz", type: 1 },
    // - - - - - - - - - - - - - - - - - - - - - - - - - - - -

    // Draw Games - - - - - - - - - - - - - - - - - - - - - - - -
    {
      displayValue: "Draw Games",
      realValue: [
        LobbyFilters.Badugi,
        LobbyFilters.VariantTripleDraw,
        LobbyFilters.FiveCardDraw,
        LobbyFilters.Badeucey,
      ],
      type: 0,
    },
    { realValue: LobbyFilters.Badugi, displayValue: "Badugi", type: 1 },
    {
      realValue: LobbyFilters.VariantTripleDraw,
      displayValue: "2-7 Tripple Draw",
      type: 1,
    },
    {
      realValue: LobbyFilters.CapSingleDraw,
      displayValue: "CAP 2-7 Tripple Draw",
      type: 1,
    },

    {
      realValue: LobbyFilters.FiveCardDraw,
      displayValue: "5 Card Draw",
      type: 1,
    },
    { realValue: LobbyFilters.Badeucey, displayValue: "Badeucey", type: 1 },
    // - - - - - - - - - - - - - - - - - - - - - - - - - - - -

    {
      realValue: LobbyFilters.VariantMixTable,
      displayValue: "Mix table",
      type: 0,
    },
  ];

  Colors = Colors;
  Currency = Currency;
  LobbyFilters = LobbyFilters;
  FilterType = FilterType;

  lobbyLoader = false;
  destroy$ = new Subject<boolean>();

  dialogPasswordRef: MatDialogRef<PasswordDialogComponent>;

  filterValue: LobbyFilterOptions;
  lobbyFilterOptions: LobbyFilterOptions;

  tournamentData: TournamentSummary;

  selectedTableId;
  selectedTableSum: TableSummary;
  selectedMixTable;

  user: User;
  logoUrl: string;

  asidePreview: string = "previewRingGames";

  selectedGameVariantFilter;

  viewingTournament: Tournament;
  playerTickets: Array<Ticket> = [];

  banners: any = {
    top: null,
    bottom: null,
  };

  enumLobbyFilters = LobbyFilters;

  tableSort: TableDataSort = { active: "ringPlayers", direction: "desc" };
  tableData: any[] = [];
  tableDb: any[] = [];

  selectedGameVariantFilterControl = new FormControl("ALL");
  search: FormControl = new FormControl("");
  lobbyStatsPlayer: PlayersStatistics;
  lobbyChatOpen: boolean = false;

  handsetPortrait = false;
  handsetLandscape = false;
  navTables: Array<NavTableData> = [];

  settings: Settings;

  showPlayerPlus = false;

  currencyInfo: CurrencyInfo[];
  emotikenCurrency: CurrencyInfo;
  skinsSettings: any;
  config;

  bannerTop$: Observable<any>;
  bannerCasino$: Observable<any>;
  bannerLobby$: Observable<any>;

  gameFilters$: Observable<any>;

  showHome = false;
  showCasino = false;
  private pendingRingNav: "HOLDEM" | "OMAHA" | null = null;
  casinosInfo$: Observable<any[]>;
  selectedCasino: any = null;
  casinoBuyInAmount: number;
  casinoProduct: string;
  showCasinoCategory = false;
  casinoUrl;
  showLobbyV2 = false;
  lobbyV2Tab = false;
  lobbyV1Tab = false;

  // Single subject to control categories loading without loop
  reloadCasinoGamesCategories$ = new BehaviorSubject<void>(undefined);
  casinoGamesCategories$: Observable<CasinoGamesCategory[]>;
  lobbyCasinoGamesCategories$: Observable<CasinoGamesCategory[]>;
  topMenuCasinoGamesCategories$ = new BehaviorSubject<CasinoGamesCategory[]>(
    [],
  );

  lobbyCasinoGamesCategoriesLoader = true;

  reloadAllCasinoGames$ = new ReplaySubject<void>();
  allCasinoGames$: Observable<any[]>;
  allCasinoGamesLoader = true;
  filteredCategoryCasinoGames$: Observable<any[]>;
  filteredAllCasinoGames$: Observable<any[]>;

  reloadCategoryCasinoGames$ = new ReplaySubject<number>();
  categoryCasinoGames$: Observable<any[]>;
  categoryCasinoGamesLoader = true;

  activeCasinoGame$ = this.managerService.activeCasinoGame$;
  activeCasinoGames$ = this.managerService.activeCasinoGames$;

  jackpotInfoBannerTextAnimation = false;
  jackpotInfoBanner$ = this.managerService.jackPotsInfo$.pipe(
    switchMap((jackpotInfo) =>
      combineLatest([
        of(jackpotInfo),
        timer(0, 4000),
        this.managerService.user$,
      ]),
    ),
    tap(([jackpotInfo, index, user]) =>
      index > 0
        ? (this.jackpotInfoBannerTextAnimation = true)
        : (this.jackpotInfoBannerTextAnimation = false),
    ),

    delay(1000),
    map(([jackpotInfo, index, user]) => {
      this.jackpotInfoBannerTextAnimation = false;

      if (jackpotInfo) {
        return {
          ...jackpotInfo[index % jackpotInfo.length],
          currencyInfo: user.selectedCurrency,
        };
      }
      return null;
    }),
  );

  searchTerm$ = new BehaviorSubject<string>(""); // inicijalno prazno

  private normalizedSearch$ = this.searchTerm$.pipe(
    map((q) => (q || "").toLowerCase().trim()),
    debounceTime(200),
    distinctUntilChanged(),
    startWith(""),
  );
  onSearchChange(value: string) {
    this.searchTerm$.next(value);
  }

  private normalString = (s: string = "") =>
    s
      .normalize("NFD")
      .replace(/\p{Diacritic}/gu, "")
      .replace(/['’‘`".,;:()\-_/\\]/g, "")
      .replace(/\s+/g, "")
      .toLowerCase();

  showPoints$: Observable<boolean>;

  newLayoutNavFilter: "ALL" | "HOLDEM" | "OMAHA" = "ALL";
  newLayoutSubnavFilter: any;

  constructor(
    public translate: TranslateService,
    public managerService: ManagerService,
    public dataManager: DataManagerService,
    public authService: AuthService,
    public mainService: MainService,
    public dialog: MatDialog,
    private gameService: GameService,
    public zone: NgZone,
    public ref: ChangeDetectorRef,
    public _webSocketService: AppWebSocketService,
    private breakpointObserver: BreakpointObserver,
    public assetsLoader: AssetsLoaderService,
    private configService: ConfigService,
    private sanitizer: DomSanitizer,
  ) {
    this.showPoints$ = combineLatest([
      this.managerService.hideShowPoints$,
      this.managerService.user$,
    ]).pipe(
      map(([hideShowPoints, user]) => {
        const config = hideShowPoints.find(
          (el) => el.Currency === user.selectedCurrency.Id,
        );

        console.log(
          "@hideShowPoints ==>",
          hideShowPoints,
          user,
          "config",
          config,
        );

        return !config?.Hide;
      }),
    );
    this.selectedGameVariantFilterControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        console.log("selectedGameVariantFilterControl", value);
        this.filterChange(FilterType.Variant, value);
      });

    // Casino Integration

    this.casinoGamesCategories$ = this.reloadCasinoGamesCategories$.pipe(
      switchMap(() => this.dataManager.getGameToken()),
      map((response) => response?.token),
      switchMap((token) => this.dataManager.getCasinoGamesCategories(token)),
      map((response) => {
        return response?.categories;
      }),
      shareReplay(1),
    );

    this.lobbyCasinoGamesCategories$ = this.casinoGamesCategories$.pipe(
      tap(() => (this.lobbyCasinoGamesCategoriesLoader = true)),
      map((categories) =>
        categories
          ?.filter((category) => category.showInMainLobby)
          .sort((a, b) => a.orderInMainMenu - b.orderInMainMenu),
      ),
      tap(() => (this.lobbyCasinoGamesCategoriesLoader = false)),
      catchError(() => {
        this.lobbyCasinoGamesCategoriesLoader = false;
        return of([]);
      }),
      shareReplay(1),
    );

    this.casinoGamesCategories$
      .pipe(
        map((categories) => {
          const filtered = categories
            ?.filter((category) => category.showInTopMenu)
            .sort((a, b) => a.orderInTopMenu - b.orderInTopMenu);
          return filtered;
        }), // filter categories that should be shown in main lobby
        takeUntil(this.destroy$),
      )
      .subscribe((filteredCategories) => {
        this.topMenuCasinoGamesCategories$.next(filteredCategories);
      });

    this.allCasinoGames$ = this.reloadAllCasinoGames$.pipe(
      tap(() => (this.allCasinoGamesLoader = true)),
      switchMap(() => this.dataManager.getGameToken()),
      map((response) => response.token),
      switchMap((token) => this.dataManager.getAllCasinoGames(token)),
      map((response) => response.categoriesWithGames),
      tap(() => (this.allCasinoGamesLoader = false)),
      map((categories) =>
        categories
          .filter((category) => category.showInMainMenu)
          .sort((a, b) => a.orderInMainMenu - b.orderInMainMenu),
      ), // filter categories that should be shown in main lobby

      shareReplay(1),
    );

    this.categoryCasinoGames$ = this.reloadCategoryCasinoGames$.pipe(
      tap(() => (this.categoryCasinoGamesLoader = true)),
      switchMap((categoryId) =>
        this.dataManager.getGameToken().pipe(
          map((response) => response.token),
          switchMap((token) =>
            this.dataManager.getCasinoGames(token, categoryId, 0),
          ),
          map((response) => response.categoriesWithGames),
        ),
      ),
      tap(() => (this.categoryCasinoGamesLoader = false)),

      shareReplay(1),
    );

    this.filteredAllCasinoGames$ = combineLatest([
      this.allCasinoGames$,
      this.normalizedSearch$,
    ]).pipe(
      map(([categories, q]) => {
        const query = this.normalString(q || "");
        if (!query) return categories;

        return categories
          .map((cat) => {
            const catName = this.normalString(
              cat.categoryName || cat.name || "",
            );
            const categoryMatch = catName.includes(query);

            if (categoryMatch) {
              return cat;
            }

            const games = (cat.games || []).filter((g) =>
              this.normalString(g.name || "").includes(query),
            );

            return { ...cat, games };
          })
          .filter((cat) => {
            const catName = this.normalString(
              cat.categoryName || cat.name || "",
            );
            return catName.includes(query) || !!(cat.games && cat.games.length);
          });
      }),
      shareReplay(1),
    );

    this.filteredCategoryCasinoGames$ = combineLatest([
      this.categoryCasinoGames$,
      this.normalizedSearch$,
    ]).pipe(
      map(([categories, q]) => {
        if (!q) return categories;
        return categories
          .map((cat) => ({
            ...cat,
            games: (cat.games || []).filter((g) =>
              (g.name || "").toLowerCase().includes(q),
            ),
          }))
          .filter((cat) => cat.games?.length);
      }),
      shareReplay(1),
    );

    this.config = this.configService.config;
    this.applyLobbyTheme(this.config?.mode ?? this.config?.lobbyTheme);
    this.configService.config$
      .pipe(takeUntil(this.destroy$))
      .subscribe((cfg) => {
        if (cfg) {
          this.config = cfg;
          this.applyLobbyTheme(cfg.mode ?? cfg.lobbyTheme);
        }
      });
    this.gameTypeFilter = this.config.lobbyGameTypeFilters;

    this.managerService.setLobbyFilterGameType(
      this.gameTypeFilter[0].realValue,
    );
    this.filterChange(FilterType.GameType, this.gameTypeFilter[0].realValue);

    if (this.config.code === "neonpoker-qijy") {
      this.lobbySound = this.assetsLoader.sound.Lobby;
      this.lobbySound.stop();

      this.lobbySound.volume(0);
      this.lobbySound.play();
      this.lobbySound.fade(0, 1, 500);
    }

    this.applyLobbyLayoutMode();

    this.managerService.casinoTokenReceivedObservable$
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        ({ token, operatorid }) => {
          const casino = this.selectedCasino;
          let queryParams = {};
          if (casino.Parameters.token && casino.Parameters.token === "##") {
            queryParams = { ...queryParams, token };
          }
          if (
            casino.Parameters.username &&
            casino.Parameters.username === "##"
          ) {
            queryParams = {
              ...queryParams,
              username: this.user.memberProfile.Username,
            };
          }
          if (
            casino.Parameters.buyInAmount &&
            casino.Parameters.buyInAmount === "##"
          ) {
            queryParams = {
              ...queryParams,
              buyInAmount: this.casinoBuyInAmount,
            };
          }
          if (
            casino.Parameters.product &&
            casino.Parameters.buyInAmount === "##"
          ) {
            queryParams = { ...queryParams, product: this.casinoProduct };
          }

          const url = `${casino.LandingUrl}?${new HttpParams({ fromObject: queryParams }).toString()}`;
          console.log("@url", url);
          this.casinoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
          console.log("casinoUrl", this.casinoUrl);

          this.managerService.setActiveTab(ENavItem.CasinoGame);
        },
      );

    this.playLobbySound(localStorage.getItem("theme"));

    this.assetsLoader.reloadObservable$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.playLobbySound(localStorage.getItem("theme"));
      });

    // console.log("config", this.config)

    this.selectedGameVariantFilter = this.gameVariantFilter[0].realValue;
    this.managerService.subscribeLiveLobby();
    this.casinosInfo$ = this.managerService.casinosInfo$;

    this.breakpointObserver
      .observe([Breakpoints.HandsetPortrait])
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        this.handsetPortrait = result.matches;
      });

    this.breakpointObserver
      .observe([Breakpoints.HandsetLandscape])
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        this.handsetLandscape = result.matches;
      });

    this.search.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe((value) => {
        if (this.useWaveLobbyUi) this.applyAllFilters();
        else {
          this.tableData = this.sortData(
            this.tableSort,
            value
              ? this.tableDb.filter((el) =>
                el.Name.toLowerCase().includes(value.toLowerCase()),
              )
              : this.tableDb,
          );
        }
      });

    this.managerService.currencyInfo$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (currencyInfo) => {
        this.currencyInfo = currencyInfo;
        this.emotikenCurrency = this.currencyInfo.find((el) => el.Id === 255);
      },
    });

    this.managerService.skinsSettings$
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (skinsSettings) => {
          this.skinsSettings = skinsSettings;
          if (!this.config) {
            return;
          }
          this.config.tileLobbyOption = !!skinsSettings?.isTileLobbyEnabled;
          if (this.useWaveLobbyUi !== this.showLobbyV2) {
            this.applyLobbyLayoutMode();
          }
        },
      });

    this.managerService.settings$.pipe().subscribe((data) => {
      // console.log("settings", data.FeatureBanners)
      // const FeatureBanners = JSON.parse(data.FeatureBanners)
      // console.log("settings FeatureBanners", FeatureBanners)
      // let lobbyBanners = FeatureBanners.find(el => el.Location === 2)
      // lobbyBanners.Banners = lobbyBanners.Banners.map(el => `${this.config.httpUrl}${el}`)
      // console.log("@lobbyBanners", lobbyBanners)
    });

    this.bannerTop$ = this.managerService.settings$.pipe(
      //take(1),
      map((settings) =>
        settings?.Banners?.filter((el) => {
          console.log("@banner", el);
          if (!this.useWaveLobbyUi) {
            return el.Position === `Top`;
          }

          return el.Position === `Right`;
        }),
      ),
      switchMap((banners) => {
        console.log("banners", banners);

        return timer(0, 6000).pipe(
          // tap((index) => {
          //   console.log('banners', banners, 'size:', banners.length, 'index:', index,)

          //   const arrayIndex = index % banners.length;
          //   const currentItem = banners[arrayIndex];
          //   // Perform any operations with the currentItem
          //   console.log(`Processing index ${arrayIndex}:`, currentItem);
          // }),
          map((index) => (banners ? banners[index % banners.length] : null)),
        );
      }),
      takeUntil(this.destroy$),
    );

    this.bannerCasino$ = this.managerService.settings$.pipe(
      //take(1),
      map((settings) =>
        settings?.Banners?.filter((el) => el.Position === `Top`),
      ),
      switchMap((banners) => {
        return timer(0, 6000).pipe(
          // tap((index) => {
          //   console.log('banners', banners, 'size:', banners.length, 'index:', index,)

          //   const arrayIndex = index % banners.length;
          //   const currentItem = banners[arrayIndex];
          //   // Perform any operations with the currentItem
          //   console.log(`Processing index ${arrayIndex}:`, currentItem);
          // }),
          map((index) => (banners ? banners[index % banners.length] : null)),
        );
      }),
      takeUntil(this.destroy$),
    );

    this.bannerLobby$ = this.managerService.settings$.pipe(
      //take(1),
      map((settings) =>
        settings?.Banners?.filter((el) => el.Position === `Lobby`),
      ),
      switchMap((banners) => {
        return timer(0, 6000).pipe(
          // tap((index) => {
          //   console.log('banners', banners, 'size:', banners.length, 'index:', index,)

          //   const arrayIndex = index % banners.length;
          //   const currentItem = banners[arrayIndex];
          //   // Perform any operations with the currentItem
          //   console.log(`Processing index ${arrayIndex}:`, currentItem);
          // }),
          map((index) => (banners ? banners[index % banners.length] : null)),
        );
      }),
      takeUntil(this.destroy$),
    );

    this.bannerTop$.subscribe((banner) => console.log("###banner", banner));

    this.managerService.settings$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (settings) => {
        this.settings = settings;

        if (!this.isCasinoEnabled && this.showCasino) {
          this.showCasino = false;
          this.showCasinoCategory = false;
        }

        this.banners.top =
          this.settings?.Banners?.find((el) => el.Position === `Top`) || null;
        this.banners.bottom =
          this.settings?.Banners?.find((el) => el.Position === `Bottom`) ||
          null;
        this.banners.right =
          this.settings?.Banners?.find((el) => el.Position === `Right`) || null;

        if (!settings) {
          // on logout return to ring games
          this.filterChange(
            FilterType.GameType,
            this.gameTypeFilter[0].realValue,
          );
        }
      },
    });

    this.managerService.reloadLobby$.pipe(takeUntil(this.destroy$)).subscribe({
      next: () => {
        this.filterChange(
          FilterType.GameType,
          this.gameTypeFilter[0].realValue,
        );
      },
    });

    this.managerService.viewTournament$
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (viewingTournament) => {
          this.viewingTournament = viewingTournament;
        },
      });
    this.isRingGame = this.config.newDesign;
    this.resetFilters();
    this.managerService.lobbyListObservable$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.tableDb = data.slice();
        this.tableData = this.sortData(
          this.tableSort,
          this.search.value
            ? data.filter((el) =>
              el.Name.toLowerCase().includes(this.search.value.toLowerCase()),
            )
            : data,
        );
        if (this.useWaveLobbyUi) this.applyAllFilters();
        if (!this.showMyTournaments) {
          this.showMyTournaments =
            this.tableData.filter((el) => el.ImRegistered).length > 0 &&
            this.currentTab === 4;
        }
        this.lobbyLoader = false;
      });

    this.managerService.activeGames$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (activeGames) => {
        // ## for mobile view
        this.navTables = Object.values(activeGames).sort((a, b) =>
          a.createdAt > b.createdAt ? -1 : 1,
        );
      },
    });

    this.managerService.lobbyStatsPlayer$
      .pipe(takeUntil(this.destroy$))
      .subscribe((lobbyStatsPlayer) => {
        this.lobbyStatsPlayer = lobbyStatsPlayer;
      });

    this.managerService.user$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (user) => {
        if (
          this.user &&
          this.user.selectedCurrency.Id !== user.selectedCurrency.Id
        ) {
          this.startLobbyListLoad();
          this.managerService.requestTableData(
            this.filterValue,
            user.selectedCurrency.Id,
          );
        }
        this.user = JSON.parse(JSON.stringify(user));
        if (this.user?.settings?.LobbyClubLogo) {
          this.logoUrl =
            this.config.httpUrl + "/" + this.user.settings.LobbyClubLogo;
        } else {
          if (
            false &&
            (this.config.code === "newwavepoker-cxzo" ||
              this.config.code === "newwavepokertest-kwwa")
          ) {
            this.logoUrl = `${environment.dataSource}/assets/${this.config.code}/logo.svg`;
          } else {
            this.logoUrl = `${environment.dataSource}/assets/${this.config.code}/logo.png`;
          }
        }
      },
    });

    this.managerService.goBackToTournaments$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        const type =
          this.managerService.lobbyFilter$.getValue().filters.TableType;
        if (data) {
          this.managerService.goBackRefreshTableSummaries(this.tableData, type);
          this.selectedGameVariantFilterControl.setValue("ALL");
          this.filterChange(FilterType.GameType, type);
          this.lobbyV2Tab = false;
          this.lobbyV1Tab = true;
        }
      });
    this.managerService.goBackToCasino$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if (data && this.isCasinoEnabled) {
          // Load categories from storage and auto-click selected category
          this.loadCategoriesFromStorageAndAutoClick();

          this.lobbyCasinoGamesCategoriesLoader = true;
          this.reloadCasinoGamesCategories$.next();
          this.reloadAllCasinoGames$.next();
          this.showHome = false;
          this.showCasino = true;
          this.showCasinoCategory = false;
        }
      });

    this.managerService.tableSumsObservable$
      .pipe(takeUntil(this.destroy$))
      .subscribe((tableSums) => {
        this.selectedTableSum = tableSums.find(
          (tableSum) => tableSum.Id === this.selectedTableId,
        );
        if (this.selectedTableSum?.Info?.Players) {
          this.selectedTableSum.players =
            this.selectedTableSum.Info.Players.filter((el) => !!el);
        }
      });

    this.managerService.mixTableObservable$
      .pipe(takeUntil(this.destroy$))
      .subscribe((mixTable) => {
        this.selectedMixTable = mixTable;
        this.asidePreview = "mix";
        if (this.selectedTableSum?.Info?.Players) {
          this.selectedTableSum.players =
            this.selectedTableSum.Info.Players.filter((el) => !!el);
        }
      });

    this.managerService.playerTickets$
      .pipe(takeUntil(this.destroy$))
      .subscribe((tickets: Ticket[]) => {
        this.playerTickets = tickets;
      });

    this.gameFilters$ = this.managerService.lobbyFilter$.pipe(
      takeUntil(this.destroy$),
      pluck("filters"),
      switchMap((lobbyFilterOptions) =>
        this.managerService.tableFilters$.pipe(
          map((tableFilters) => {
            if (tableFilters) {
              if (lobbyFilterOptions.TableType === 1) {
                return tableFilters.RingFilters;
              }
              if (lobbyFilterOptions.TableType === 2) {
                return tableFilters.SitNGoFilters;
              }
              if (lobbyFilterOptions.TableType === 4) {
                return tableFilters.TournamentFilters;
              }
              if (lobbyFilterOptions.TableType === 16) {
                return tableFilters.SpinNGoFilters;
              }
            }

            return {};
          }),
        ),
      ),
      tap((d) => console.log("F:,", d)),
    );

    this.managerService.lobbyFilter$
      .pipe(
        takeUntil(this.destroy$),
        pluck("filters"),
        tap((lobbyFilterOptions) => {
          this.filterValue = lobbyFilterOptions;
          this.lobbyFilterOptions = lobbyFilterOptions;
          this.onChangeGameType(lobbyFilterOptions.TableType);
          this.startLobbyListLoad();
        }),
        debounceTime(50),
      )
      .subscribe((lobbyFilterOptions) => {
        this.managerService.requestTableData(
          lobbyFilterOptions,
          this.user.selectedCurrency.Id,
        );
      });

    this.managerService.showPlayerPlus$
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        this.showPlayerPlus = value;
      });
    if (this.useWaveLobbyUi) this.resetFilters();
    if (this.useWaveLobbyUi) this.resetRingFilters();
  }

  onClear(input: ElementRef<HTMLInputElement> | HTMLInputElement) {
    const el = input instanceof ElementRef ? input.nativeElement : input;
    this.onSearchChange("");
    // iOS/Safari ponekad traži mali delay da bi fokus ostao + tastatura ostala otvorena
    setTimeout(() => {
      el.focus();
      // pomeri kursor na kraj (nije nužno, ali deluje prirodno)
      try {
        el.setSelectionRange(0, 0);
      } catch { }
    }, 0);
  }

  // CLOSE (X): briše, zatvara tastaturu i skida fokus
  onClose(input: ElementRef<HTMLInputElement> | HTMLInputElement) {
    const el = input instanceof ElementRef ? input.nativeElement : input;
    this.onSearchChange("");
    // prvo blur da zatvori tastaturu
    el.blur();
  }

  async playLobbySound(localStorageTheme) {
    const themes = this.config.themes;

    if (themes) {
      const theme = themes.find((el) => el.name === localStorageTheme);
      if (theme && theme.sound.lobby) {
        this.lobbySound = this.assetsLoader.sound[theme.name + "-lobby"];
        this.lobbySound.stop();

        this.lobbySound.volume(0);
        this.lobbySound.play();
        this.lobbySound.fade(0, 1, 500);
      }
    }
  }

  openCashier() {
    this.managerService.setActiveTab(ENavItem.Cashier);
  }

  editProfile() {
    this.dialog.open(EditProfileComponent, {
      width: "300px",
      data: this.user.memberProfile,
    });
  }

  openTournament(tournamentId) {
    this.managerService.setActiveTab(ENavItem.Tournament);
    this.managerService.tournamentView({
      Id: tournamentId,
    } as TournamentSummary);
  }

  playClickSound() {
    const themes = this.config.themes;
    if (themes && themes.length > 0) {
      const theme = themes.find(
        (el) => el.name === localStorage.getItem("theme"),
      );
      if (theme && theme.sound.click) {
        this.assetsLoader.sound[theme.name + "-click"].play();
      }
    }
  }

  loadSound(soundUrl: string): Promise<Howl> {
    return new Promise((resolve, reject) => {
      const sound = new Howl({ src: [soundUrl], loop: true });

      if (sound.state() === "loaded") {
        resolve(sound);
      } else if (sound.state() === "unloaded") {
        resolve(sound);
      } else {
        sound.once("load", () => {
          resolve(sound);
        });
      }
    });
  }

  onPlayerPlusOk() {
    this.dataManager.playerAlignmentInitiate();
  }

  onTableClick(navTableData: NavTableData) {
    this.mainService.hideSidenav();
    this.managerService.setActiveTab(ENavItem.Game);
    this.managerService.setActiveGame(navTableData.table.IdTable);
  }

  showCasinosInfo() {
    this.mainService.showCasino();
  }

  ngOnDestroy(): void {
    if (this.lobbySound) {
      this.lobbySound.fade(1, 0, 500);
      setTimeout(() => {
        this.lobbySound.stop();
      }, 500);
    }
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  viewTournament(tableSelectedData: TournamentSummary, redirection?: boolean) {
    if (
      tableSelectedData.HasPassword &&
      tableSelectedData.IsLocked &&
      redirection
    ) {
      this.dialogPasswordRef = this.dialog.open(PasswordDialogComponent);

      this.dialogPasswordRef.afterClosed().subscribe((password: string) => {
        if (password) {
          const subscription =
            this.managerService.tournamentInformationObservable$.subscribe(
              (IdTournament: number) => {
                if (redirection) {
                  this.managerService.setActiveTab(ENavItem.Tournament);
                }
                subscription.unsubscribe();
              },
            );
          this.managerService.tournamentView(tableSelectedData, password);

          setTimeout(() => {
            subscription.unsubscribe();
          }, 500);
        }
      });
    } else if (!tableSelectedData.HasPassword || !tableSelectedData.IsLocked) {
      this.managerService.tournamentView(tableSelectedData);
      if (redirection) {
        this.managerService.setActiveTab(ENavItem.Tournament);
      }
    }
  }

  // unlockGift() {
  //   this.managerService.unlockGift(this.dataManager.getGiftIdForUnlock(this.user, this.settings), this.user, this.settings);
  // }

  // ===================

  openGame(gameCode: string, name: string) {
    console.log("openGame", this.user.memberProfile);

    // Save current top categories to storage
    const currentCategories = this.topMenuCasinoGamesCategories$.getValue();
    localStorage.setItem(
      "topCasinoCategories",
      JSON.stringify(currentCategories),
    );

    if (!this.user.memberProfile.ProfileUpdated) {
      const dialogRef = this.dialog.open(GenericTextDialog);

      dialogRef.componentInstance.textHeader = "Profile Update";
      dialogRef.componentInstance.textBody =
        "Please complete your profile in order to play the casino game.";
      dialogRef.componentInstance.textAcceptBtn = "Update Profile ";
      dialogRef.componentInstance.textDismissBtn = "Skip for now";

      dialogRef.componentInstance.enableAccept = true;
      dialogRef.componentInstance.enableClose = true;

      dialogRef
        .afterClosed()
        .pipe(take(1))
        .subscribe((confirmed) => {
          if (confirmed) {
            this.dialog.open(EditProfileComponent, {
              width: "300px",
              data: this.user.memberProfile,
            });
          }
        });
      return;
    }

    this.dataManager
      .getGameToken()
      .pipe(
        map((response) => response.token),
        switchMap((token) =>
          this.dataManager.getCasinoGameLaunchUrl(
            token,
            gameCode,
            this.user.selectedCurrency.Name,
            false,
          ),
        ),
      )
      .subscribe((response) => {
        console.log("openGame", response);
        this.managerService.setActiveCasinoGame({
          url: response.url,
          gameCode: response.gameCode,
          name,
        });
      });
  }
  onOpenCategoryGames(categoryId: number) {
    // Save selected category ID to storage
    localStorage.setItem("selectedCasinoCategoryId", categoryId.toString());

    this.reloadCategoryCasinoGames$.next(categoryId);

    this.showHome = false;
    this.showCasino = true;
    this.showCasinoCategory = true;
  }

  loadCategoriesFromStorageAndAutoClick() {
    // Load categories from storage
    const savedCategories = localStorage.getItem("topCasinoCategories");
    if (savedCategories) {
      try {
        const categories = JSON.parse(savedCategories);
        this.topMenuCasinoGamesCategories$.next(categories);

        // Auto-click on selected category
        const selectedCategoryId = localStorage.getItem(
          "selectedCasinoCategoryId",
        );
        if (selectedCategoryId) {
          // Small delay to ensure categories are rendered
          setTimeout(() => {
            this.onOpenCategoryGames(parseInt(selectedCategoryId));
          }, 100);
        }
      } catch (error) {
        console.error("Error loading categories from storage:", error);
      }
    }
  }

  btnOnOpenHome() {
    this.showHome = true;
    this.showCasino = false;
    this.showCasinoCategory = false;
  }

  private applyLobbyLayoutMode(): void {
    if (this.useWaveLobbyUi) {
      this.showLobbyV2 = true;
      this.lobbyV2Tab = true;
      this.lobbyV1Tab = false;
      this.btnOnOpenHome();
    } else if (this.config?.lobbyHome) {
      this.btnOnOpenHome();
    } else {
      this.showLobbyV2 = false;
      this.lobbyV2Tab = false;
      this.lobbyV1Tab = true;
    }
  }

  btnOnOpenCasino() {
    if (!this.isCasinoEnabled) {
      return;
    }
    this.reloadAllCasinoGames$.next();
    this.showHome = false;
    this.showCasino = true;
    this.showCasinoCategory = false;
  }

  changeFilterByKey(fieldName: string, value: any) {
    const currentList = this[fieldName] as any[];

    const updatedList = currentList.includes(value)
      ? currentList.filter((el: any) => el !== value)
      : [...currentList, value];

    this[fieldName] = updatedList;

    switch (fieldName) {
      case "selectedBuyIn":
        this.applyAllFilters("buyIn", value);
        break;
      case "selectedTourStatus":
        this.applyAllFilters("tourStatus", value);
        break;
      case "selectedStake":
        this.filterItems("Stake", value);
        break;
      case "selectedSpeed":
        this.filterItems("Speed", value);
        break;
      case "selectedLimit":
        this.filterItems("Limit", value);
        break;
      case "selectedTableOption":
        this.showEmptyRingTables(value);
        break;
    }
  }

  changeCompleted() {
    if (this.selectedCompletedOption.length) {
      this.selectedCompletedOption = [];
    } else {
      this.selectedCompletedOption.push(true);
    }
    this.applyAllFilters();
  }

  changeSatelites() {
    if (this.selectedHideSatelitites.length) {
      this.selectedHideSatelitites = [];
    } else {
      this.selectedHideSatelitites.push(true);
    }
    this.applyAllFilters();
  }

  filterItems(
    name: "Stake" | "Speed" | "Limit" | "TableOption",
    value: number,
  ) {
    console.log("filterItems", name, value);
    if (value === 0) {
      this["selected" + name] = [0];
    } else if (this["selected" + name].includes(0)) {
      this["selected" + name] = this["selected" + name].filter(
        (el) => el !== 0,
      );
    }
    if (this["selected" + name].length) {
      switch (name) {
        case "Stake":
          this.managerService.setLobbyFilterStake(this.selectedStake);
          break;
        case "Speed":
          this.managerService.setLobbyFilterSpeed(this.selectedSpeed);
          break;
        case "Limit":
          this.managerService.setLobbyFilterLimit(this.selectedLimit);
          break;
        case "TableOption":
          this.managerService.setLobbyFilterNbSeats(this.selectedTableOption);
          break;
      }
    } else {
      this["selected" + name] = [0];
      switch (name) {
        case "Stake":
          this.managerService.setLobbyFilterStake(null);
          break;
        case "Speed":
          this.managerService.setLobbyFilterSpeed(null);
          break;
        case "Limit":
          this.managerService.setLobbyFilterLimit(null);
          break;
        case "TableOption":
          this.managerService.setLobbyFilterNbSeats(null);
          break;
      }
    }

    this.sortFromFilters(this.selectedSortOption);
  }

  showPrivateTable(show: number) {
    if (
      (this.showPrivate.length &&
        this.showPrivate.includes(0) &&
        this.showPrivate.includes(1)) ||
      !this.showPrivate.length
    ) {
      this.managerService.setLobbyFilterTableOptions(0);
    } else {
      this.managerService.setLobbyFilterTableOptions(show);
    }
  }

  showEmptyRingTables(value: number) {
    if (value === 0) {
      this.selectedTableOption = [0];
    } else if (this.selectedTableOption.includes(0)) {
      this.selectedTableOption = this.selectedTableOption.filter(
        (el) => el !== 0,
      );
    }
    if (this.selectedTableOption.length === 0) this.selectedTableOption = [0];
    if (this.selectedTableOption.includes(0)) {
      this.managerService.setLobbyFilterTableEmptyFull(false, false);
    } else {
      this.managerService.setLobbyFilterTableEmptyFull(
        this.selectedTableOption.includes(1),
        this.selectedTableOption.includes(2),
      );
    }
    this.sortFromFilters(this.selectedSortOption);
  }

  applyAllFilters(filterName: string = "", filterValue: any = null) {
    let filteredData = this.tableDb.slice();

    if (filterName && filterValue !== null) {
      // Filter by BuyIn
      if (filterName === "buyIn") {
        if (filterValue === 0) {
          this.selectedBuyIn = [0];
        } else if (this.selectedBuyIn.includes(0)) {
          this.selectedBuyIn = this.selectedBuyIn.filter((el) => el !== 0);
        }

        this.managerService.setLobbyFilterStake(
          filterValue !== 0 ? this.selectedBuyIn : null,
        );
      }
      if (filterName === "tourStatus") {
        if (filterValue === 0) {
          this.selectedTourStatus = [0];
        } else if (this.selectedTourStatus.includes(0)) {
          this.selectedTourStatus = this.selectedTourStatus.filter(
            (el) => el !== 0,
          );
        }
      }
    }
    if (this.selectedBuyIn.length === 0) this.selectedBuyIn = [0];
    if (this.selectedTourStatus.length === 0) {
      this.selectedTourStatus = [0];
    }
    // Filter by Tournament Status
    if (
      this.selectedTourStatus &&
      this.selectedTourStatus.length > 0 &&
      !this.selectedTourStatus.includes(TournamentStatus2.Hidden)
    ) {
      filteredData = filteredData.filter((el) =>
        this.selectedTourStatus.includes(el.Status2),
      );
    }
    // Filter by Completed
    if (this.selectedCompletedOption.length) {
      filteredData = filteredData.filter(
        (el) => el.Status2 === TournamentStatus2.Completed,
      );
    }
    if (this.selectedHideSatelitites.length) {
      filteredData = filteredData.filter((el) => {
        const prizeId = el?.PrizeIdTicket;
        return prizeId === 0 || prizeId === undefined;
      });
    }
    //Filter user Tournaments
    if (this.myTournaments) {
      filteredData = filteredData.filter((el) => el.ImRegistered);
    }
    if (this.search.value) {
      filteredData = filteredData.filter((el) =>
        el.Name.toLowerCase().includes(this.search.value.toLowerCase()),
      );
    }
    this.tableData = this.sortData(this.tableSort, filteredData);
  }

  resetFilters() {
    if (this.isRingGame) {
      this.resetRingFilters();
    } else {
      this.selectedTourStatus = [0];
      this.selectedBuyIn = [0];
      this.selectedCompletedOption = [];
      this.selectedHideSatelitites = [];
      this.myTournaments = false;
      this.managerService.setLobbyFilterStake(null);
      this.managerService.setLobbyFilterSpeed(null);
      this.managerService.setLobbyFilterLimit(null);
      this.managerService.setLobbyFilterNbSeats(null);
      this.managerService.showEmptyTablesChange(true);
      this.applyAllFilters();
    }
  }

  resetRingFilters() {
    this.tableData = this.tableDb.slice();
    this.selectedStake = [0];
    this.selectedSpeed = [0];
    this.selectedLimit = [0];
    this.selectedSortOption = false;
    this.selectedTableOption = [0];
    this.showPrivate = [];
    this.managerService.setLobbyFilterStake(null);
    this.managerService.setLobbyFilterSpeed(null);
    this.managerService.setLobbyFilterLimit(null);
    this.managerService.setLobbyFilterNbSeats(null);
    this.showEmptyRingTables(0);
    this.applyAllFilters();
  }

  saveFilters() {
    switch (this.previuosTab) {
      case LobbyFilters.TypeSitnGo:
        this.sitNGoFilters = {
          status: this.selectedTourStatus,
          buyIn: this.selectedBuyIn,
          completed: this.selectedCompletedOption,
          hideSatelitites: this.selectedHideSatelitites,
        };
        break;
      case LobbyFilters.TypeTournament:
        this.tournamentFilters = {
          status: this.selectedTourStatus,
          buyIn: this.selectedBuyIn,
          completed: this.selectedCompletedOption,
          hideSatelitites: this.selectedHideSatelitites,
        };
        break;
      case LobbyFilters.TypeSpinAndGo:
        this.spinNGoFilters = {
          status: this.selectedTourStatus,
          buyIn: this.selectedBuyIn,
          completed: this.selectedCompletedOption,
          hideSatelitites: this.selectedHideSatelitites,
        };
        break;
      default:
        break;
    }
  }

  showResetButtonCondition() {
    if (this.isRingGame) {
      return (
        !this.selectedStake.length ||
        this.selectedStake.length > 1 ||
        (this.selectedStake.length === 1 && this.selectedStake[0] !== 0) ||
        this.selectedSortOption ||
        this.selectedTableOption.length > 1 ||
        !this.selectedTableOption.length ||
        (this.selectedTableOption.length === 1 &&
          this.selectedTableOption[0] !== 0) ||
        !this.selectedSpeed.length ||
        this.selectedSpeed.length > 1 ||
        (this.selectedSpeed.length === 1 && this.selectedSpeed[0] !== 0) ||
        !this.selectedLimit.length ||
        this.selectedLimit.length > 1 ||
        (this.selectedLimit.length === 1 && this.selectedLimit[0] !== 0) ||
        this.showPrivate.length > 0
      );
    } else {
      return (
        !this.selectedTourStatus.length ||
        this.selectedTourStatus.length > 1 ||
        (this.selectedTourStatus.length === 1 &&
          this.selectedTourStatus[0] !== 0) ||
        this.selectedBuyIn.length > 1 ||
        !this.selectedBuyIn.length ||
        (this.selectedBuyIn.length === 1 && this.selectedBuyIn[0] !== 0) ||
        this.selectedCompletedOption.length ||
        this.selectedHideSatelitites.length
      );
    }
  }

  // ===================

  filterChange(type, value, index?: number) {
    if (type === FilterType.GameType) {
      this.tableData = [];
    }
    this.showHome = false;
    this.showCasino = false;
    this.startLobbyListLoad();
    if (!this.previuosTab) this.previuosTab = value;
    else this.previuosTab = this.currentTab;
    this.currentTab = value;

    this.showFilters = false;
    this.showDesktopFilters = false;
    // this.saveFilters(); removed for now
    // this.showResetButton = this.showResetButtonCondition();

    this.managerService.tournamentView(null);
    this.viewingTournament = null;
    this.isRingGame = value === 1;
    if (this.useWaveLobbyUi) this.resetFilters();

    this.managerService.stopTournamentCountDown();

    switch (type) {
      case FilterType.GameType:
        this.managerService.setLobbyFilterGameType(value);
        if (!this.pendingRingNav) {
          this.selectedGameType = "ALL";
          this.setNav("ALL");
        }
        switch (value) {
          case LobbyFilters.TypeRing:
            this.managerService.useSmartSortChange(true);
            this.tableSort = { active: "ringPlayers", direction: "desc" };
            this.selectedGameVariantFilter = "ALL";
            if (!this.pendingRingNav) {
              this.managerService.setLobbyFilterLimit(null);
              this.managerService.setLobbyFilterVariant(null);
            }

            break;
          case LobbyFilters.TypeSitnGo:
            this.managerService.useSmartSortChange(true);
            this.tableSort = { active: "sngPlayers", direction: "desc" };
            this.selectedGameVariantFilter = "ALL";
            this.managerService.setLobbyFilterLimit(null);
            this.managerService.setLobbyFilterVariant(null);

            break;
          case LobbyFilters.TypeTournament:
            this.managerService.useSmartSortChange(true);
            this.tableSort = { active: "scheduler", direction: "asc" };
            this.selectedGameVariantFilter = "ALL";
            this.managerService.setLobbyFilterLimit(null);
            this.managerService.setLobbyFilterVariant(null);

            break;
          case LobbyFilters.TypeSpinAndGo:
            this.managerService.useSmartSortChange(true);
            this.tableSort = { active: "name", direction: "desc" };
            this.selectedGameVariantFilter = "ALL";
            this.managerService.setLobbyFilterLimit(null);
            this.managerService.setLobbyFilterVariant(null);

            break;

          default:
            break;
        }
        break;
      case FilterType.Variant:
        if (value === "ALL") {
          value = null;
        }
        if (this.useWaveLobbyUi) {
          this.managerService.useSmartSortChange(true);
          this.managerService.setLobbyFilterVariant(null);
        } else
          this.managerService.setLobbyFilterVariant(
            Array.isArray(value) ? value : [value],
          );
        break;
      case FilterType.Limit:
        this.managerService.setLobbyFilterLimit(value);
        break;
      case FilterType.Stakes:
        this.managerService.setLobbyFilterStake(value);
        break;
      case FilterType.TableOption:
        this.managerService.setLobbyFilterTableOptions(value);
        break;
      case FilterType.Speed:
        this.managerService.setLobbyFilterSpeed(value);
        break;

      default:
        break;
    }
  }

  onChangeGameType(lobbyFilter: LobbyFilters) {
    this.search.setValue("", { emitEvent: false });

    switch (lobbyFilter) {
      case LobbyFilters.TypeRing:
        this.managerService.stopTournamentCountDown();
        this.selectedTableSum = undefined;
        this.selectedTableId = undefined;
        this.selectedMixTable = undefined;
        this.asidePreview = "previewRingGames";

        break;
      case LobbyFilters.TypeSitnGo:
        this.managerService.stopTournamentCountDown();
        this.selectedTableSum = undefined;
        this.selectedTableId = undefined;
        this.selectedMixTable = undefined;
        this.asidePreview = "previewSitNGo";

        break;
      case LobbyFilters.TypeTournament:
        this.managerService.startTournamentCountDown();
        this.selectedTableSum = undefined;
        this.selectedTableId = undefined;
        this.selectedMixTable = undefined;
        this.asidePreview = "previewTourney";

        break;
      case LobbyFilters.TypeSpinAndGo:
        this.managerService.startTournamentCountDown();
        this.selectedTableSum = undefined;
        this.selectedTableId = undefined;
        this.selectedMixTable = undefined;
        this.asidePreview = "previewSpinNGo";

        break;
    }
  }

  mainFilterClick() {
    this.mainService.toggleRightSidenav();
  }

  isObject(o) {
    return (
      null != o &&
      typeof o === "object" &&
      Object.prototype.toString.call(o) === "[object Object]"
    );
  }

  onChatOpenClose($event: boolean) {
    this.lobbyChatOpen = $event;
  }

  sortFromFilters(isAsc: boolean) {
    this.tableData = this.sortData(
      { direction: isAsc ? "asc" : "desc", active: "ringPlayers" },
      this.tableData,
    );
  }
  sortChange($event) {
    const name = $event?.sort?.data;
    if ($event?.sort?.active === "smartSort") {
      var dataSource = this.tableDb.slice();
      this.tableSort = {
        direction: this.tableSort.direction,
        active: "smartSort",
        data: name,
      };
      dataSource.sort((a, b) => {
        if (name === "tableRingGames") {
          return Comparators.smartSortingPlayerComparator(a, b);
        } else if (name === "tableSitNGo" || name === "tableSpinNGo") {
          return Comparators.playerComparator(
            a,
            b,
            $event?.sort?.direction === "asc",
          );
        } else if (name === "tableTourney") {
          return Comparators.dateComparator(
            a.DateStarting,
            b.DateStarting,
            true,
          );
        }
      });
      this.tableData = dataSource;
    } else {
      this.tableData = this.sortData($event.sort, this.tableData);
    }
  }

  sortData(sort: TableDataSort, arr: any[]) {
    this.tableSort = sort;
    const data = arr.slice();
    if (!sort.active || sort.direction === "") {
      return data;
    }

    if (sort.active === "smartSort") {
      this.sortChange({ sort: this.tableSort });
      return this.tableData;
    }
    const sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === "asc";
      switch (sort.active) {
        case "tableId":
          return Comparators.compare(+a.Id, +b.Id, isAsc);
        case "variant":
          return Comparators.compare(a.tableVariant, b.tableVariant, isAsc);
        case "speed":
          return Comparators.compare(a.tableSpeed, b.tableSpeed, isAsc);
        case "ringPlayers":
          return Comparators.smartSortingPlayerComparator(a, b, isAsc);
        case "tourPlayers":
          return Comparators.playerComparator(a, b, isAsc);
        case "sngPlayers":
          return Comparators.playerComparator(a, b, isAsc);
        case "wait":
          return Comparators.compare(+a.tableWait, +b.tableWait, isAsc);
        case "stakes":
          return Comparators.compare(a.minStake, b.minStake, isAsc);
        case "buyIn":
          return Comparators.buyInComparator(a, b, isAsc);
        case "limit":
          return Comparators.compare(a.tableLimit, b.tableLimit, isAsc);
        case "name":
          return Comparators.compare(a.Name, b.Name, isAsc);
        case "date":
          return Comparators.dateComparator(
            a.DateStarting,
            b.DateStarting,
            isAsc,
          );
        case "scheduler":
          return Comparators.dateComparator(
            a.DateStarting,
            b.DateStarting,
            isAsc,
          );
        case "averagePot":
          return Comparators.compare(a.AveragePot, b.AveragePot, isAsc);
        case "guarantee":
          return Comparators.compare(
            a.PrizeGuaranteed,
            b.PrizeGuaranteed,
            isAsc,
          );
        case "status":
          return Comparators.statusCompare(a, b, isAsc);

        default:
          return 0;
      }
    });

    return sortedData;
  }

  preview() {
    switch (this.lobbyFilterOptions.TableType) {
      case LobbyFilters.TypeRing:
        this.asidePreview = "previewRingGames";
        break;
      case LobbyFilters.TypeSitnGo:
        this.asidePreview = "previewSitNGo";
        break;
      case LobbyFilters.TypeTournament:
        this.asidePreview = "previewTourney";
        break;
      case LobbyFilters.TypeSpinAndGo:
        this.asidePreview = "previewSpinNGo";
        break;
    }
  }

  onTableRowClick(row: any): void {
    switch (this.lobbyFilterOptions.TableType) {
      case LobbyFilters.TypeRing:
        this.selectedTableId = row.Id;
        if (window.innerWidth < 1280) {
          this.managerService.gamestartFromTableSummeries(row);
        } else {
          this.dataManager.getTableDetail(row.Id);
          this.selectedMixTable = null;
          this.asidePreview = "previewRingGames";

          if (row.isMixTable) {
            this.dataManager.getMixTablesDetails(row.Id);
          }
        }

        break;
      case LobbyFilters.TypeSitnGo:
        this.selectedTableId = row.Id;
        if (window.innerWidth < 1280) {
          this.viewTournament(row, true);
        } else {
          this.asidePreview = "previewSitNGo";
          this.selectedTableSum = row;
          this.viewingTournament = new Tournament();
          this.viewingTournament.tourSum = row;
          this.viewTournament(row);
        }

        break;
      case LobbyFilters.TypeTournament:
        this.selectedTableId = row.Id;
        if (window.innerWidth < 1280) {
          this.viewTournament(row, true);
        } else {
          this.asidePreview = "previewTourney";
          this.selectedTableSum = row;
          this.viewingTournament = new Tournament();
          this.viewingTournament.tourSum = row;
          this.viewTournament(row);
        }

        break;

      case LobbyFilters.TypeSpinAndGo:
        this.selectedTableId = row.Id;
        if (window.innerWidth < 1280) {
          this.viewTournament(row, true);
        } else {
          this.asidePreview = "previewSpinNGo";
          this.selectedTableSum = row;
          this.viewingTournament = new Tournament();
          this.viewingTournament.tourSum = row;
          this.viewTournament(row);
        }

        break;
    }
  }

  startRingGame(tableSummary: TableSummary) {
    this.managerService.gamestartFromTableSummeries(tableSummary);
  }

  openLegendSymbol() {
    this.dialog.open(DialogLegendSymbol, {
      width: "300px",
    });
  }

  openFilters() {
    this.mainService.toggleRightSidenav();
  }

  openCallTimeInfo(row) {
    const dialogRef = this.dialog.open(GenericTextDialog, {
      width: "300px",
      disableClose: false,
    });

    dialogRef.componentInstance.textHeader = "Call Time";
    dialogRef.componentInstance.textBody = `
<div><strong>> +${row.CallTimeConfiguration.CallTimePercent}%</strong></div>
<div>${row.CallTimeConfiguration.CallTimeDuration}min</div>
`;

    dialogRef.componentInstance.enableClose = false;

    dialogRef.componentInstance.enableAccept = false;
  }

  openJackpotInfo(data) {
    console.log("openJackpotInfo", this.user.selectedCurrency);
    this.managerService.jackPotsInfo$
      .pipe(take(1))
      .subscribe((jackPotsInfo) => {
        let jackpot: any;
        for (const item of jackPotsInfo) {
          if (item.Id === data.Id) {
            jackpot = item;
            jackpot.prizePool = CurrencyPipe.prototype.transform(
              CurrencyDeviderPipe.prototype.transform(
                item.PrizePool,
                this.user.selectedCurrency,
              ),
              this.user.selectedCurrency,
            );
          }
        }

        const dialogRef = this.dialog.open(GenericTextDialog, {
          width: "300px",
          disableClose: false,
        });

        dialogRef.componentInstance.textHeader = jackpot.Name;
        dialogRef.componentInstance.textBody = `
    <div>${jackpot.prizePool}</div>
    <div>${jackpot.Description}</div>
    `;

        dialogRef.componentInstance.textDismissBtn = `OK`;

        dialogRef.componentInstance.enableAccept = false;
      });
  }

  //++++

  confirmCasinoForm() {
    this.processCasino();
  }

  processCasino() {
    this.mainService.openCasinoFromLobby(
      this.casinoBuyInAmount,
      this.casinoProduct,
    );
  }

  lobbyV2Holdem() {
    this.homeOpenHoldem();
    this.lobbyV2Tab = false;
    this.lobbyV1Tab = true;
  }
  lobbyV2SitAndGo() {
    this.selectedGameVariantFilterControl.setValue("ALL");

    this.filterChange(FilterType.GameType, 2);
    this.lobbyV2Tab = false;
    this.lobbyV1Tab = true;
  }
  lobbyV2SpinAndGo() {
    this.selectedGameVariantFilterControl.setValue("ALL");

    this.filterChange(FilterType.GameType, 16);
    this.lobbyV2Tab = false;
    this.lobbyV1Tab = true;
  }
  lobbyV2Tourney() {
    this.selectedGameVariantFilterControl.setValue("ALL");

    this.filterChange(FilterType.GameType, 4);
    this.lobbyV2Tab = false;
    this.lobbyV1Tab = true;
  }

  lobbyV2Omaha() {
    this.homeOpenOmaha();
    this.lobbyV2Tab = false;
    this.lobbyV1Tab = true;
  }

  lobbyV2Home() {
    this.lobbyV2Tab = true;
    this.lobbyV1Tab = false;
  }

  lobbyV2Poker() {
    this.filterChange(FilterType.GameType, LobbyFilters.TypeRing);
    this.lobbyV2Tab = false;
    this.lobbyV1Tab = true;
  }

  lobbyV2Cashier() {
    this.managerService.setActiveTab(ENavItem.Cashier);
  }

  lobbyV2Profile() {
    this.dialog.open(EditProfileComponent, {
      width: "300px",
      data: this.user.memberProfile,
    });
  }

  homeOpenCashGames(): void {
    this.showHome = false;
    this.filterChange(FilterType.GameType, LobbyFilters.TypeRing);
  }

  private startLobbyListLoad(): void {
    if (!this.showHome && !this.showCasino) {
      this.lobbyLoader = true;
    }
  }

  homeOpenHoldem(): void {
    this.pendingRingNav = "HOLDEM";
    this.filterChange(FilterType.GameType, LobbyFilters.TypeRing);
    this.onGameTypeChange("HOLDEM");
    this.pendingRingNav = null;
  }

  homeOpenOmaha(): void {
    this.pendingRingNav = "OMAHA";
    this.filterChange(FilterType.GameType, LobbyFilters.TypeRing);
    this.onGameTypeChange("OMAHA");
    this.pendingRingNav = null;
  }

  homeOpenSitAndGo(): void {
    this.lobbyV2SitAndGo();
  }

  homeOpenTournaments(): void {
    this.lobbyV2Tourney();
  }

  homeOpenSpinAndGo(): void {
    this.lobbyV2SpinAndGo();
  }

  openCasinoGame(game) {
    this.managerService.setActiveCasinoGame(game);
  }

  setNav(value: "ALL" | "HOLDEM" | "OMAHA") {
    this.newLayoutNavFilter = value;
    if (value === "ALL") {
      this.managerService.setLobbyFilterVariant([]);
      return;
    }
    if (value === "HOLDEM") {
      this.setLimit(LobbyFilters.LimitAny);
      return;
    }
    if (value === "OMAHA") {
      this.setOmaha();
      return;
    }
  }

  setLimit(value: LobbyFilters) {
    this.managerService.setLobbyFilterLimit(value);
    this.newLayoutSubnavFilter = value;
    this.managerService.setLobbyFilterVariant([LobbyFilters.VariantHoldem]);
  }

  setCapTexasHoldem(value: LobbyFilters) {
    this.setLimit(LobbyFilters.LimitAny);
    this.newLayoutSubnavFilter = value;
    this.managerService.setLobbyFilterVariant([
      LobbyFilters.VariantCapTexasHoldEm,
    ]);
  }

  setOmaha(value?: LobbyFilters) {
    this.newLayoutSubnavFilter = value;
    this.setLimit(LobbyFilters.LimitAny);
    if (!value) {
      this.newLayoutSubnavFilter = "omaha_all";
      this.managerService.setLobbyFilterVariant([
        LobbyFilters.VariantOmaha3,
        LobbyFilters.VariantOmaha,
        LobbyFilters.VariantOmaha5,
        LobbyFilters.VariantOmaha6,
        LobbyFilters.CapOmaha,
        LobbyFilters.CapOmaha5,
        LobbyFilters.CapOmaha6,
        LobbyFilters.CapOmaha7,
      ]);
      return;
    } else {
      this.newLayoutSubnavFilter = value;
    }
    this.managerService.setLobbyFilterVariant([value as LobbyFilters]);
  }

  trackLobbyBanner(_index: number, banner: any): string {
    return banner?.Img || banner?.Action || "";
  }

  lockBannerSize(event: Event): void {
    const img = event.target as HTMLImageElement;
    if (!(img instanceof HTMLImageElement) || !img.naturalWidth || !img.naturalHeight) {
      return;
    }

    const banner = img.closest(".banner") as HTMLElement | null;
    if (!banner || !banner.closest(".handset-portrait-mode")) {
      return;
    }

    if (!banner.style.getPropertyValue("aspect-ratio")) {
      banner.style.setProperty(
        "aspect-ratio",
        `${img.naturalWidth} / ${img.naturalHeight}`,
      );
      banner.classList.add("banner-size-locked");
    }
  }

  onGameTypeChange(value: string | LobbyFilters) {
    if (value === "ALL") {
      this.selectedGameType = "ALL";
      this.managerService.setLobbyFilterVariant([]);
      return;
    }

    if (value === "HOLDEM") {
      this.selectedGameType = LobbyFilters.VariantHoldem;
      this.setNav("HOLDEM");
      return;
    }

    if (value === "OMAHA") {
      this.selectedGameType = LobbyFilters.VariantOmaha;
      this.setNav("OMAHA");
      return;
    }

    this.selectedGameType = value;
    this.setOmaha(value as LobbyFilters);
  }

  private applyLobbyTheme(theme: string | undefined): void {
    this.lobbyTheme = theme === "light" ? "light" : "dark";
  }

  getTableNameColor(item: { Color?: string }): string {
    if (item?.Color) {
      return this.Colors[item.Color];
    }
    return this.lobbyTheme === "light" ? "#000000" : "#fff";
  }
}
